/**
 * Copyright 2016, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
module.exports = require('./dist/lib/devtools-plugin')['default'];
module.exports.Actions = require('./dist/components/Actions')['default'];
module.exports.ActionTree = require('./dist/components/ActionTree')['default'];
